import api from './axiosInstance'

export default {
    addConductorTypes(payload) {
        return api.post('conductorTypes', payload);
    },
    updateConductor(id, payload) {
        return api.put('conductorTypes/' + id, payload);
    },
    getAllConductor() {
        return api.get('conductorTypes');
    },
    getConductor(id) {
        return api.get('conductorTypes/'+id);
    },
}